
import Foot from "@/layouts/foot";
export default {
  name: "index",
  components: {Foot},
  head() {
    return {
      title: 'Οι συνεργάτες μας',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: "Servislet araç sahipleri ile araç servislerinin bir araya geldiği platformdur. Aracın için en uygun servisi bulabilirsin."
        },
        { hid: 'keywords', name: 'keywords', content: "servislet, michelin, euromaster, ako, lastik, ako lastik, sigorta, petlas, dunlop, falken, kormoran, bfgoodrich, koalay, kasko sigortası, kasko" }
      ],
    }
  },
}
